import { render, staticRenderFns } from "./FamiliesList.vue?vue&type=template&id=1d6105a7"
import script from "./FamiliesList.vue?vue&type=script&lang=js"
export * from "./FamiliesList.vue?vue&type=script&lang=js"
import style0 from "./FamiliesList.vue?vue&type=style&index=0&id=1d6105a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports